import { useMemo } from "react";

import { HeatGrid } from "../../map/HeatGrid";
import type { MapMode } from "../../map/MapMode";
import type { MapScene } from "../../map/MapScene";

const createHeat = (scene: MapScene) => {
  const canvas = document.createElement("canvas");
  canvas.width = HeatGrid.size;
  canvas.height = HeatGrid.size;
  return { grid: new HeatGrid(scene.heatPath), canvas };
};

// Тепловой след игрока на отдельном canvas. В «весь матч» — за весь матч, в «до момента» —
// до `t`; при движении ползунка пересчитывается только разница.
export const useHeat = (scene: MapScene, t: number, mode: MapMode): HTMLCanvasElement => {
  const heat = useMemo(() => createHeat(scene), [scene]);
  const count = mode === "all" ? scene.heatPath.length : Math.floor(t / scene.stepS) + 1;
  useMemo(() => {
    heat.grid.setCount(count);
    const context = heat.canvas.getContext("2d");
    if (context !== null) {
      const image = context.createImageData(HeatGrid.size, HeatGrid.size);
      heat.grid.paint(image);
      context.putImageData(image, 0, 0);
    }
  }, [heat, count]);
  return heat.canvas;
};
